







import { Component, Vue, Prop } from 'vue-property-decorator';
import { MyTrainInfo } from '@/data/train-store';
import TrainRideLine from './TrainRideLine.vue';

@Component({
  components: { TrainRideLine }
})
export default class TrainStation extends Vue {
  @Prop(String) public stationId!: string;
  @Prop(String) public platformId!: string;
}
